import {
  isPhoneGap
} from '@/modules/util/util'
import {
  ModuleInfo
} from '@/config/nameConfig'
import * as Helper from '@/modules/helper/index'

import {
  mergeUserActionQueue,
  selectUserActionQueue,
  dropUserActionQueueEntry,
  mergeUserActionQueueEntryWithModuleContentPagesTables,
  mergeUserActionQueueEntryWithModuleImageGalleriesTables,
  mergeUserActionQueueEntryWithModulesRadioStreamTables,
  mergeModulesContentPagesPostsComments
} from '@/dbQuery/dbInteractions'

import {
  Post
} from '@/modules/wrapper/apiWrapper'

export default {
  onCommentAdded(payload) {
    processEntry(payload)
  },
  onPostLikeAdded(payload) {
    processEntry(payload)
  },
  onFormDataAdded(payload) {
    processEntry(payload)
  }
}
const processEntry = async(payload) => {
  let uaq = []
  uaq.push(payload)
  if (isPhoneGap()) {
    let dbpayload = Object.assign({}, payload)
    dbpayload.Payload = JSON.stringify(dbpayload.Payload)
    mergeUserActionQueue(dbpayload)
  }
  await Post('ProcessUAQ', uaq).then(response => {
    if (isPhoneGap()) {
      if (Helper.IsValid(response, true)) {
        response.forEach(action => {
          if (action.IsProcessed) {
            let processeduaq = uaq.find(a => a.Id === action.Id)
            if (typeof processeduaq.Payload.ContentType !== 'undefined') {
              switch (processeduaq.Payload.ContentType) {
                case 1:
                  processeduaq.Payload.tableName = ModuleInfo.Tables.ModulesContentPagesPosts
                  processeduaq.Payload.keyColumn = ModuleInfo.Primarykey.Id
                  mergeUserActionQueueEntryWithModuleContentPagesTables(processeduaq)
                  break
                case 2:
                  processeduaq.Payload.tableNameArray = [ModuleInfo.Tables.ModulesImageGalleriesAlbums, ModuleInfo.Tables.ModulesImageGalleriesAlbumsImages]
                  processeduaq.Payload.keyColumn = ModuleInfo.Primarykey.Id
                  mergeUserActionQueueEntryWithModuleImageGalleriesTables(processeduaq)
                  break
                case 3:
                  processeduaq.Payload.tableName = ModuleInfo.Tables.ModulesRadioStream
                  processeduaq.Payload.keyColumn = ModuleInfo.Primarykey.Id
                  mergeUserActionQueueEntryWithModulesRadioStreamTables(processeduaq)
                  break
                default:
                  break
              }
            } else {
              if (action.Payload) {
                processeduaq.Payload.RowCreated = action.Payload.RowCreated
                processeduaq.Payload.RowUpdated = action.Payload.RowUpdated
                processeduaq.Payload.CommentDate = action.Payload.CommentDate
                mergeModulesContentPagesPostsComments(processeduaq.Payload)
              }
            }
            dropUserActionQueueEntry(action.Id)
          }
        })
      } else {
        let processeduaq = uaq[0]
        if (typeof processeduaq.Payload.ContentType !== 'undefined') {
          switch (processeduaq.Payload.ContentType) {
            case 1:
              processeduaq.Payload.tableName = ModuleInfo.Tables.ModulesContentPagesPosts
              processeduaq.Payload.keyColumn = ModuleInfo.Primarykey.Id
              mergeUserActionQueueEntryWithModuleContentPagesTables(processeduaq)
              break
            case 2:
              processeduaq.Payload.tableNameArray = [ModuleInfo.Tables.ModulesImageGalleriesAlbums, ModuleInfo.Tables.ModulesImageGalleriesAlbumsImages]
              processeduaq.Payload.keyColumn = ModuleInfo.Primarykey.Id
              mergeUserActionQueueEntryWithModuleImageGalleriesTables(processeduaq)
              break
            case 3:
              processeduaq.Payload.tableName = ModuleInfo.Tables.ModulesRadioStream
              processeduaq.Payload.keyColumn = ModuleInfo.Primarykey.Id
              mergeUserActionQueueEntryWithModulesRadioStreamTables(processeduaq)
              break
            default:
              break
          }
        } else {
          // processeduaq.Payload.RowCreated = action.Payload.RowCreated
          // processeduaq.Payload.RowUpdated = action.Payload.RowUpdated
          processeduaq.Payload.CommentDate = ''
          mergeModulesContentPagesPostsComments(processeduaq.Payload)
        }
      }
    }
  }, response => {
    console.log(' error response', response) // error callback
  })
}

export const processStartUpUAQEntry = async() => {
  if (isPhoneGap()) {
    let actions = await selectUserActionQueue()
    if (Helper.IsValid(actions, true)) {
      let uaq = []
      actions.forEach(action => {
        action.Payload = JSON.parse(action.Payload)
        uaq.push(action)
      })
      await Post('ProcessUAQ', uaq).then(response => {
        if (Helper.IsValid(response, true)) {
          if (isPhoneGap()) {
            response.forEach(action => {
              if (action.IsProcessed) {
                let processeduaq = uaq.find(a => a.Id === action.Id)
                if (typeof processeduaq.Payload.ContentType !== 'undefined') {
                  switch (processeduaq.Payload.ContentType) {
                    case 1:
                      processeduaq.Payload.tableName = ModuleInfo.Tables.ModulesContentPagesPosts
                      processeduaq.Payload.keyColumn = ModuleInfo.Primarykey.Id
                      mergeUserActionQueueEntryWithModuleContentPagesTables(processeduaq)
                      break
                    case 2:
                      processeduaq.Payload.tableNameArray = [ModuleInfo.Tables.ModulesImageGalleriesAlbums, ModuleInfo.Tables.ModulesImageGalleriesAlbumsImages]
                      processeduaq.Payload.keyColumn = ModuleInfo.Primarykey.Id
                      mergeUserActionQueueEntryWithModuleImageGalleriesTables(processeduaq)
                      break
                    case 3:
                      processeduaq.Payload.tableName = ModuleInfo.Tables.ModulesRadioStream
                      processeduaq.Payload.keyColumn = ModuleInfo.Primarykey.Id
                      mergeUserActionQueueEntryWithModulesRadioStreamTables(processeduaq)
                      break
                    default:
                      break
                  }
                } else {
                  if (action.Payload) {
                    processeduaq.Payload.RowCreated = action.Payload.RowCreated
                    processeduaq.Payload.RowUpdated = action.Payload.RowUpdated
                    processeduaq.Payload.CommentDate = action.Payload.CommentDate
                    mergeModulesContentPagesPostsComments(processeduaq.Payload)
                  }
                }
                dropUserActionQueueEntry(action.Id)
              }
            })
          }
        }
      }, response => {
        console.log(' error response', response) // error callback
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/modules/uaq/uaqSync.js